import '../../../css/eq.css'

import { useRef, useEffect, useState } from "react";
import { useSelector} from 'react-redux';

import { DEFAULT } from '../../../config/data';
import { selectFilters, selectAudioSrc} from '../../../features/counter/selectors';

import AudioEnv from "../plugins/AudioEnv";
import MainCanvas from "../canvas/MainCanvas";
import ProgressBar from "../../../UI/ProgressBar";
import VolumeSlider from '../../../UI/VolumeSlider'
import PlayButton from '../../../UI/PlayButton'
import FilterControllers from '../../../UI/controllers/FilterControllers';


const DEFAULT_VOLUME = DEFAULT.DEFAULT_SETTINGS.volume;
const DEFAULT_Filter = DEFAULT.DEFAULT_FILTER;

function AudioEngine() {
    console.log('1')
    const filters = useSelector(selectFilters);
    const audioSrc = useSelector(selectAudioSrc);

    const audioEnvRef = useRef(null);
    const [isInitialized, setIsInitialized] = useState(false);
    const [rawData, setRawData] = useState(null); // State to store raw audio data
    const [duration, setDuration] = useState(1);
    const [volume, setVolume] = useState(DEFAULT_VOLUME);
    const [playStatus, setPlayStatus] = useState(false);


    // Cleanup method
    const cleanupEnv = () => {
        if (audioEnvRef.current) {
            audioEnvRef.current.cleanup();
            audioEnvRef.current = null;
        }
        setIsInitialized(false);
        setRawData(null); // Reset raw data on cleanup
    };

    const initAudioEnv = async (src) => {
        const env = new AudioEnv(src);
        const def = DEFAULT_Filter;
        env.setGain(DEFAULT_VOLUME);
        def.forEach((f, i) => {
            env.addProcessor(i, "eq", {
                type: f.type,
                frequency: f.frequency,
                gain: f.gain,
                Q: f.Q,
                detune: f.detune,
                bypass: f.bypass
            });
        });

        // Set duration when metadata is loaded
        env.getAudioElement().addEventListener("loadedmetadata", () => {
            setDuration(env.getAudioElement().duration);
        });

        // Fetch raw audio data
        try {
            const data = await env.getRawAudioData(); // Wait for raw data
            setRawData(data); // Store raw data in state
        } catch (error) {
            console.error("Error fetching raw audio data:", error);
        }

        audioEnvRef.current = env;
        setIsInitialized(true);
    };

    useEffect(() => {
        if (audioSrc) {
            console.log('init')
            initAudioEnv(audioSrc);
        }
        return () => {
            console.log('clear')
            cleanupEnv();
        };
    }, [audioSrc]);

    useEffect(() => {
        const env = audioEnvRef.current;
        if (env && isInitialized) {
            env.updateAllProcessors(filters);
        }
    }, [filters, isInitialized]);


    return (
        <div className="audio-engine">
            {!isInitialized && <div className='loading-screen'>Loading Audio Environment...</div>}
            {isInitialized && (
                <>
                    <MainCanvas audioEnv={audioEnvRef.current} />
                    <div className="audio-operation-container container">
                        <div className="play-volume-container container">
                            <PlayButton audioEnv={audioEnvRef.current} playStatus={playStatus} setPlayStatus={setPlayStatus} />
                            <VolumeSlider audioEnv={audioEnvRef.current} volume={volume} setVolume={setVolume} />
                        </div>
                        <ProgressBar audioEnv={audioEnvRef.current} rawData={rawData} duration={duration} />
                    </div>
                    <FilterControllers />
                </>

            )}
        </div>
    );
}

export default AudioEngine;
